/**
 * Os tres estados de uma consulta, num lugar so: esperando, falhou, chegou.
 *
 * Existe para que as telas nao repitam (e nao divirjam) o tratamento de erro. O importante aqui e
 * o caminho do erro: ele mostra a frase traduzida E oferece tentar de novo - sem o botao, uma
 * falha momentanea do Auth obriga a recarregar a pagina inteira e perder a sessao de trabalho.
 */

import { Button } from '@ledger-glass/react'
import type { UseQueryResult } from '@tanstack/react-query'
import type { ReactNode } from 'react'

import { Alert } from '../components/Alert'
import { Skeleton } from '../components/Skeleton'
import { humanizar } from '../errors/humanizar'

export function Resultado<T>({
  consulta,
  children,
}: {
  consulta: UseQueryResult<T>
  children: (dados: T) => ReactNode
}) {
  if (consulta.isPending) return <Skeleton height={220} />
  if (consulta.error !== null) {
    return (
      <Alert
        tone="danger"
        action={<Button onClick={() => void consulta.refetch()}>Tentar de novo</Button>}
      >
        {humanizar(consulta.error)}
      </Alert>
    )
  }
  return <>{children(consulta.data)}</>
}
